import { useState, useEffect, useCallback } from "react";
import { makeApiRequest, apiRoutes } from "constants/apiRoutes";
import { useAuth } from "utilities/auth";

const DEFAULT_PAGINATION = { page: 1, limit: 25, total: 0, totalPages: 1 };

export function useUsers({ filters = {}, page = 1, limit = 25, sort = "email", companyId: overrideCompanyId } = {}) {
  const [users, setUsers] = useState([]);
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { user } = useAuth();
  const companyId = overrideCompanyId || user?.companyId;

  const fetchUsers = useCallback(async () => {
    if (!user?.id) return;
    setLoading(true);
    setError(null);

    try {
      const params = new URLSearchParams();
      params.set("page", String(page));
      params.set("limit", String(limit));
      params.set("sort", sort);

      if (overrideCompanyId) params.set("companyId", overrideCompanyId);

      for (const [key, val] of Object.entries(filters)) {
        if (val !== undefined && val !== "") params.set(key, val);
      }

      const url = `${apiRoutes.getCompanyUsers}?${params.toString()}`;
      const res = await makeApiRequest(
        "get",
        url,
        { id: user.id, accessToken: user.accessToken },
        companyId
      );

      const body = res?.data || {};
      setUsers(body.data || []);
      setPagination(body.pagination || DEFAULT_PAGINATION);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [user?.id, user?.accessToken, companyId, overrideCompanyId, page, limit, sort, filters]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  return { users, pagination, loading, error, refetch: fetchUsers };
}
